import { useEffect } from "react";

export const useOffScrollOnMount = () => {
	useEffect(() => {
		document.body.style.overflow = "hidden";

		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);
};
